// extracted by mini-css-extract-plugin
module.exports = {"autoScrollWrap":"AutoScroll_autoScrollWrap__WisFB","switchArrow":"AutoScroll_switchArrow__blOiA","autoScroll":"AutoScroll_autoScroll__4VERb"};